import type { FrontendWidget } from '../types';
import { MagazineArticleListComponent } from './MagazineArticleListComponent';
import {
  DEFAULT_NUMBER_OF_ITEMS,
  type MagazineArticleListConfig,
  type MagazineArticleListResolved,
} from './types';

export const magazineArticleListWidget: FrontendWidget<
  MagazineArticleListConfig,
  MagazineArticleListResolved
> = {
  componentType: 'magazine.article-list',
  displayName: 'Magazine Article List',
  defaultValues: { numberOfItems: DEFAULT_NUMBER_OF_ITEMS },
  ComponentA: MagazineArticleListComponent,
  // No resolveSync — lookup widget. The backend resolver scopes the grid from
  // the tag bag and hands back the first batch.
};
